var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRatingStar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7118 8.54433C11.4136 8.84743 11.2781 9.28424 11.3479 9.71264L11.7984 12.4539C11.9388 13.3072 11.2892 14.0002 10.5524 14.0002C10.3582 14.0002 10.1578 13.9519 9.9636 13.8455L7.60635 12.5512C7.42196 12.4504 7.22011 12.4 7.01756 12.4C6.81571 12.4 6.61386 12.4504 6.42947 12.5512L4.07222 13.8455C3.87805 13.9519 3.6776 14.0002 3.48343 14.0002C2.74657 14.0002 2.09702 13.3072 2.23741 12.4539L2.6879 9.71264C2.75775 9.28424 2.62225 8.84743 2.32401 8.54433L0.416562 6.6032C-0.333567 5.83949 0.0806103 4.50877 1.1171 4.35126L3.75303 3.95156C4.16511 3.88926 4.52132 3.61905 4.70501 3.22915L5.88399 0.735711C6.11587 0.245004 6.56706 0 7.01756 0C7.46876 0 7.91995 0.245004 8.15183 0.735711L9.33081 3.22915C9.5145 3.61905 9.87071 3.88926 10.2828 3.95156L12.9187 4.35126C13.9552 4.50877 14.3694 5.83949 13.6193 6.6032L11.7118 8.54433Z",
    fill: "#FFC468"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRatingStar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rating-star.761f730c.svg";
export { ForwardRef as ReactComponent };